import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=b3ed66f4&scoped=true"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"
import style0 from "./introduce.vue?vue&type=style&index=0&id=b3ed66f4&prod&lang=css"
import style1 from "./introduce.vue?vue&type=style&index=1&id=b3ed66f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ed66f4",
  null
  
)

export default component.exports